export default __webpack_public_path__ + "static/media/case_04.74bf3250.jpg";